import { render, staticRenderFns } from "./FighterCreate.vue?vue&type=template&id=7856d800&lang=pug"
import script from "./FighterCreate.vue?vue&type=script&lang=js"
export * from "./FighterCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports